import { Pipe, PipeTransform } from '@angular/core';
import { Transaction } from '../../data/models';

/**
 * Formats a transaction's creation date into dd.MM.yyyy format
 * @example {{ transaction | formatDate }} -> "23.01.2025"
 */
@Pipe({
    name: 'formatDate',
    standalone: false
})
export class FormatDatePipe implements PipeTransform {
  transform(transaction : Transaction | null): string | undefined {
    return transaction?.createdAt?.toFormat('dd.MM.yyyy');
  }
}
